import { render, staticRenderFns } from "./BtnLike.vue?vue&type=template&id=65509614&scoped=true"
import script from "./BtnLike.vue?vue&type=script&lang=js"
export * from "./BtnLike.vue?vue&type=script&lang=js"
import style0 from "./BtnLike.vue?vue&type=style&index=0&id=65509614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65509614",
  null
  
)

export default component.exports